import React from 'react'

export const DetailPromotion = () => {
  return (
    <div>Detail</div>
  )
}
